(function () {
  'use strict';

  var TOTAL_STEPS = 7;
  var RECAP_STEP = 8;
  var DRAFT_KEY = 'lcu_wizard_draft';
  var DRAFT_TTL_MS = 24 * 60 * 60 * 1000;

  var root = document.querySelector('[data-lcu-wizard]');
  if (!root) return;

  var form = root.querySelector('#lcu-wizard-form');
  if (!form) return;

  var strings = readStrings();
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var progressItems = Array.prototype.slice.call(root.querySelectorAll('[data-progress-step]'));
  var intro = root.querySelector('[data-wizard-intro]');
  var currentStep = 1;
  var maxStepReached = 1;
  var isSubmitting = false;
  var isRestoring = false;
  var funnelTargets = null;

  // Le filtre `t` de Shopify echappe le HTML (« d'homme » devient
  // « d&#39;homme ») et ces textes sont poses en textContent : sans decodage,
  // l'entite s'affiche telle quelle. Un <textarea> decode sans rien executer.
  function decodeEntities(value) {
    if (typeof value !== 'string' || value.indexOf('&') === -1) return value;
    var area = document.createElement('textarea');
    area.innerHTML = value;
    return area.value;
  }

  function readStrings() {
    var node = root.querySelector('[data-wizard-strings]');
    if (!node) return {};
    try {
      var parsed = JSON.parse(node.textContent);
      Object.keys(parsed).forEach(function (key) {
        parsed[key] = decodeEntities(parsed[key]);
      });
      return parsed;
    } catch (e) {
      return {};
    }
  }

  function t(key, replacements) {
    var value = strings[key] || '';
    if (!replacements) return value;
    Object.keys(replacements).forEach(function (token) {
      value = value.split(token).join(replacements[token]);
    });
    return value;
  }

  function routeFor(name, fallback) {
    if (window.routes && window.routes[name]) return window.routes[name];
    return fallback;
  }

  function checkoutUrl() {
    var base = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      base = window.Shopify.routes.root;
    }
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'checkout';
  }

  function stepNode(index) {
    for (var i = 0; i < steps.length; i++) {
      if (parseInt(steps[i].getAttribute('data-step'), 10) === index) return steps[i];
    }
    return null;
  }

  function syncFold() {
    var body = root.querySelector('.lcu-wizard__step.is-active .lcu-wizard__step-body');
    if (!body) return;

    var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
    root.style.setProperty('--wz-fold', Math.max(0, Math.round(body.getBoundingClientRect().top + scrolled)) + 'px');

    var host = root.closest('.shopify-section') || root;
    var tail = host.getBoundingClientRect().bottom - body.getBoundingClientRect().bottom;
    root.style.setProperty('--wz-tail', Math.max(0, Math.round(tail)) + 'px');
  }

  function belowFormSections() {
    if (funnelTargets) return funnelTargets;
    funnelTargets = [];

    var host = root.closest('.shopify-section');
    if (host && host.parentElement) {
      Array.prototype.forEach.call(host.parentElement.children, function (node) {
        if (node !== host) funnelTargets.push(node);
      });
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.shopify-section-group-footer-group'),
      function (node) {
        if (funnelTargets.indexOf(node) === -1) funnelTargets.push(node);
      }
    );

    return funnelTargets;
  }

  function setFunnelFocus(engaged) {
    if (window.Shopify && window.Shopify.designMode) return;
    belowFormSections().forEach(function (node) {
      node.classList.toggle('lcu-funnel-hidden', engaged);
    });
    document.body.classList.toggle('lcu-funnel-focus', engaged);
  }

  function showStep(index, options) {
    var opts = options || {};
    var target = stepNode(index);
    if (!target) return;

    cancelAutoAdvance();

    steps.forEach(function (step) {
      step.classList.toggle('is-active', step === target);
    });
    currentStep = index;
    if (index > maxStepReached) maxStepReached = index;
    trackClarity('wizard_step_view_' + index, { wizard_step: index, wizard_max_step: maxStepReached });

    if (intro) intro.hidden = index !== 1;

    setFunnelFocus(index > 1 && index < RECAP_STEP);

    updateProgress();
    refreshRecap();
    saveDraft();
    syncFold();
    window.requestAnimationFrame(syncFold);

    if (opts.scroll !== false) {
      root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    if (opts.focus === false) return;

    // Sur mobile, focus un champ texte ouvre le clavier des qu'on appuie sur
    // « Continuer » : la question de l'etape se retrouve masquee. On deplace le
    // focus sur l'etape elle-meme — les lecteurs d'ecran annoncent la nouvelle
    // question, le clavier reste ferme jusqu'a ce que le client touche le champ.
    var firstField = target.querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea');
    if (firstField && !isTouchLike()) {
      firstField.focus({ preventScroll: true });
      return;
    }

    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  function isTouchLike() {
    if (!window.matchMedia) return false;
    return window.matchMedia('(pointer: coarse)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateProgress() {
    progressItems.forEach(function (item) {
      var index = parseInt(item.getAttribute('data-progress-step'), 10);
      item.classList.toggle('is-current', index === currentStep);
      item.classList.toggle('is-done', index < currentStep);
    });
  }

  function validateStep(index, options) {
    var step = stepNode(index);
    if (!step) return true;

    var report = !options || options.report !== false;
    var errorNode = root.querySelector('[data-wizard-error="' + index + '"]');
    if (errorNode && report) errorNode.hidden = true;

    var fields = step.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.disabled || field.type === 'hidden') continue;
      if (field.checkValidity()) continue;
      if (!report) return false;

      if (field.type === 'radio' && errorNode) {
        errorNode.hidden = false;
        field.focus({ preventScroll: true });
        errorNode.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
        return false;
      }

      field.reportValidity();
      field.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
      return false;
    }
    return true;
  }

  function clearStepErrorIfValid(index) {
    var errorNode = root.querySelector('[data-wizard-error="' + index + '"]');
    if (!errorNode || errorNode.hidden) return;
    if (validateStep(index, { report: false })) errorNode.hidden = true;
  }

  function goNext(fromStep) {
    if (!validateStep(fromStep)) return;
    trackStep(fromStep);
    showStep(fromStep >= TOTAL_STEPS ? RECAP_STEP : fromStep + 1);
  }

  function trackStep(index) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'lcu_wizard_step_completed', wizard_step: index });
    } catch (e) {
    }
  }

  // Entonnoir Microsoft Clarity (app embed Shopify, window.clarity est global).
  // Un evenement par etape affichee + le clic paiement : dans Clarity, Funnels
  // -> etapes wizard_step_view_1 ... wizard_step_view_8 -> wizard_pay_click.
  // Le tag wizard_step permet de filtrer les enregistrements par derniere etape vue.
  // Tout est protege : si Clarity est absent ou bloque, rien ne change.
  function trackClarity(eventName, tags) {
    try {
      if (typeof window.clarity !== 'function') return;
      if (tags) {
        Object.keys(tags).forEach(function (key) {
          window.clarity('set', key, String(tags[key]));
        });
      }
      window.clarity('event', eventName);
    } catch (e) {
    }
  }

  root.addEventListener('click', function (event) {
    var next = event.target.closest('[data-wizard-next]');
    if (next) {
      event.preventDefault();
      goNext(parseInt(next.getAttribute('data-wizard-next'), 10));
      return;
    }

    var back = event.target.closest('[data-wizard-back]');
    if (back) {
      event.preventDefault();
      showStep(parseInt(back.getAttribute('data-wizard-back'), 10), { focus: false });
    }
  });

  // Avance automatique sur les etapes a choix unique ([data-auto-advance]) :
  // toucher une carte suffit, sans passer par « Continuer ».
  // - Le delai laisse voir la carte se colorer avant le changement d'ecran ;
  //   un second appui pendant ce delai remplace le choix.
  // - Les cartes qui ouvrent un champ « Précisez » (data-toggle-target)
  //   restent manuelles : il faut pouvoir ecrire.
  // - Seul un vrai clic souris/doigt compte (event.detail > 0). Au clavier,
  //   fleches et Espace selectionnent sans changer d'etape ; « Continuer »
  //   valide. Desactive dans l'editeur de theme.
  // - Re-toucher la carte deja cochee (retour arriere) avance aussi.
  // - Juste apres une avance, les appuis sur la nouvelle etape sont ignores
  //   un instant. Sur mobile la barre « Continuer » ne bouge pas : l'appui
  //   reflexe sur Continuer (ou un double appui lent sur une carte)
  //   tomberait sur l'etape suivante — erreur affichee, etape sautee ou
  //   option cochee sans le vouloir.
  var AUTO_ADVANCE_DELAY_MS = 400;
  var AUTO_ADVANCE_SETTLE_MS = 1000;
  var autoAdvanceTimer = null;
  var settleUntil = 0;

  function cancelAutoAdvance() {
    if (!autoAdvanceTimer) return;
    window.clearTimeout(autoAdvanceTimer);
    autoAdvanceTimer = null;
  }

  root.addEventListener(
    'click',
    function (event) {
      if (Date.now() >= settleUntil) return;
      if (!event.target.closest || !event.target.closest('.lcu-wizard__step')) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  // Les radios sont masquees (pointer-events: none) : le clic arrive sur le
  // libelle, avant que le navigateur coche la radio. On verifie donc l'etat
  // coche a la fin du delai, pas ici.
  form.addEventListener('click', function (event) {
    if (event.detail === 0) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var label = event.target.closest ? event.target.closest('label') : null;
    var input = label ? label.querySelector('input[type="radio"]') : null;
    if (!input) return;

    var step = input.closest('[data-auto-advance]');
    if (!step) return;

    var index = parseInt(step.getAttribute('data-step'), 10);
    if (index !== currentStep) return;

    cancelAutoAdvance();
    if (input.hasAttribute('data-toggle-target')) return;

    autoAdvanceTimer = window.setTimeout(function () {
      autoAdvanceTimer = null;
      if (currentStep !== index || !input.checked) return;
      goNext(index);
      if (currentStep !== index) settleUntil = Date.now() + AUTO_ADVANCE_SETTLE_MS;
    }, AUTO_ADVANCE_DELAY_MS);
  });

  function toggleReveal(node, show) {
    if (!node) return;
    node.hidden = !show;
    node.setAttribute('aria-hidden', show ? 'false' : 'true');
    var field = node.querySelector('input, textarea');
    if (!field) return;
    if (show) {
      field.removeAttribute('tabindex');
    } else {
      field.setAttribute('tabindex', '-1');
      field.value = '';
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function initConditionalFields() {
    form.querySelectorAll('input[type="radio"][data-toggle-target]').forEach(function (radio) {
      var targetId = radio.getAttribute('data-toggle-target');
      var group = form.querySelectorAll('input[type="radio"][name="' + radio.name + '"]');

      Array.prototype.forEach.call(group, function (sibling) {
        sibling.addEventListener('change', function () {
          if (!sibling.checked) return;
          toggleReveal(document.getElementById(targetId), sibling === radio);
        });
      });
    });

    form.querySelectorAll('select[data-toggle-select-target]').forEach(function (select) {
      var targetId = select.getAttribute('data-toggle-select-target');
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        toggleReveal(document.getElementById(targetId), !!(option && option.hasAttribute('data-toggle-other')));
      });
    });

    form.querySelectorAll('input[type="checkbox"][data-checkbox-reveal]').forEach(function (checkbox) {
      var targetId = checkbox.getAttribute('data-checkbox-reveal');
      checkbox.addEventListener('change', function () {
        var target = document.getElementById(targetId);
        toggleReveal(target, checkbox.checked);
        if (!checkbox.checked || !target) return;

        var field = target.querySelector('textarea, input');
        if (!field) return;

        // Meme regle qu'au changement d'etape : sur mobile, ouvrir le clavier
        // des que la case est cochee recouvre l'option qu'on vient de choisir.
        // On amene simplement le champ revele dans l'ecran.
        if (isTouchLike()) {
          field.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
        } else {
          field.focus({ preventScroll: true });
        }
      });
    });
  }

  function initCharCounters() {
    form.querySelectorAll('[data-char-limit]').forEach(function (field) {
      var limit = parseInt(field.getAttribute('data-char-limit'), 10);
      var counter = form.querySelector('[data-counter-for="' + field.id + '"]');
      if (!limit || !counter) return;

      function refresh() {
        var used = field.value.length;
        var visible = used > limit * 0.8;
        counter.hidden = !visible;
        counter.textContent = t('counter', { '[used]': used, '[total]': limit });
        counter.classList.toggle('is-warn', used > limit * 0.9);
      }

      field.addEventListener('input', refresh);
      refresh();
    });
  }

  function initExclusiveOptions() {
    form.querySelectorAll('[data-exclusive-group]').forEach(function (label) {
      var group = label.getAttribute('data-exclusive-group');
      var input = label.querySelector('.lcu-wizard__option-input');
      if (!input) return;

      input.addEventListener('change', function () {
        if (!input.checked) return;
        form.querySelectorAll('[data-exclusive-group="' + group + '"] .lcu-wizard__option-input').forEach(function (other) {
          if (other === input) return;
          if (!other.checked) return;
          other.checked = false;
          other.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function formatPrice(value) {
    var suffix = root.getAttribute('data-currency-suffix') || '';
    var rounded = Math.round(value * 100) / 100;
    if (rounded % 1 === 0) return rounded + suffix;
    var text = rounded.toFixed(2).replace('.', ',');
    return text + suffix;
  }

  function refreshPrice() {
    var base = parseFloat(root.getAttribute('data-base-price')) || 0;
    var total = base;

    form.querySelectorAll('[data-option-price]').forEach(function (input) {
      if (!input.checked || input.disabled) return;
      total += parseFloat(input.getAttribute('data-option-price')) || 0;
    });

    root.querySelectorAll('[data-price-display]').forEach(function (node) {
      node.textContent = formatPrice(total);
    });

    refreshBreakdown();
  }

  function optionLabel(input) {
    return input.getAttribute('data-breakdown-label') || input.getAttribute('data-addon-label') || input.value;
  }

  function breakdownAction(input, list) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lcu-wizard__breakdown-action';

    if (input.type === 'checkbox') {
      button.textContent = t('breakdown_remove_short');
      button.setAttribute('aria-label', t('breakdown_remove', { '[option]': optionLabel(input) }));
      button.addEventListener('click', function () {
        input.click();
        list.focus({ preventScroll: true });
      });
      return button;
    }

    var slot = input.getAttribute('data-recap-slot');
    var trigger = slot ? root.querySelector('[data-recap-edit="' + cssEscape(slot) + '"]') : null;
    if (!trigger) return null;

    button.textContent = t('breakdown_change');
    button.setAttribute('aria-label', t('breakdown_change') + ' — ' + optionLabel(input));
    button.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
      var panel = root.querySelector('[data-recap-editor="' + cssEscape(slot) + '"]');
      var champ = panel ? panel.querySelector('select, input, textarea') : null;
      if (panel) revealEditor(champ, panel);
      else trigger.focus({ preventScroll: true });
    });
    return button;
  }

  function breakdownRow(list, label, montant, action) {
    var row = document.createElement('li');
    row.className = 'lcu-wizard__breakdown-row';
    row.setAttribute('data-breakdown-option', '');

    var texte = document.createElement('span');
    texte.className = 'lcu-wizard__breakdown-label';
    texte.textContent = label;
    row.appendChild(texte);

    if (action) row.appendChild(action);

    var prix = document.createElement('span');
    prix.className = 'lcu-wizard__breakdown-price';
    prix.textContent = montant;
    row.appendChild(prix);

    list.appendChild(row);
  }

  function refreshBreakdown() {
    var list = root.querySelector('[data-recap-breakdown]');
    if (!list) return;

    // La ligne de la chanson est rendue en Liquid : on ne vide que les options.
    list.querySelectorAll('[data-breakdown-option]').forEach(function (row) {
      row.remove();
    });

    var livraison = form.querySelector('.lcu-wizard__tier-input:checked');
    if (livraison) {
      var supplement = parseFloat(livraison.getAttribute('data-option-price')) || 0;
      if (supplement > 0) {
        breakdownRow(
          list,
          t('recap_delai') + ' — ' + livraison.value,
          formatPrice(supplement),
          breakdownAction(livraison, list)
        );
      }
    }

    form.querySelectorAll('[data-option-price]').forEach(function (input) {
      if (!input.checked || input.disabled) return;
      if (input.classList.contains('lcu-wizard__tier-input')) return;
      var prix = parseFloat(input.getAttribute('data-option-price')) || 0;
      if (prix <= 0) return;
      breakdownRow(list, optionLabel(input), formatPrice(prix), breakdownAction(input, list));
    });
  }

  function nowInParis() {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Paris',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      var parts = {};
      fmt.formatToParts(new Date()).forEach(function (part) {
        if (part.type !== 'literal') parts[part.type] = parseInt(part.value, 10);
      });
      return { hour: parts.hour === 24 ? 0 : parts.hour, minute: parts.minute };
    } catch (e) {
      var date = new Date();
      return { hour: date.getHours(), minute: date.getMinutes() };
    }
  }

  function buildEta(tier, h) {
    var isNight = h < 6;

    if (tier === 'standard') {
      if (isNight) return t('eta_standard_night');
      return t('eta_standard', { '[h]': h });
    }

    if (tier === 'express') {
      if (isNight) return t('eta_express_night');
      if (h < 12) return t('eta_express_tonight', { '[h]': h + 12 });
      if (h < 18) return t('eta_tomorrow_six');
      return t('eta_express_tomorrow', { '[h]': (h + 12) % 24 });
    }

    if (tier === 'flash') {
      if (isNight) return t('eta_flash_night');
      if (h < 12) return t('eta_flash_today', { '[h]': h + 6 });
      if (h < 18) return t('eta_flash_tonight', { '[h]': h + 6 });
      return t('eta_tomorrow_six');
    }

    return '';
  }

  function initDeliverySelector() {
    var container = root.querySelector('[data-wizard-delivery]');
    if (!container) return;

    container.querySelectorAll('[data-delivery-benefit]').forEach(function (node) {
      node.setAttribute('data-default-text', node.textContent);
    });

    var paris = nowInParis();
    var h = paris.hour;

    // Le prioritaire est disponible a toute heure (decision du 07/09/2026).
    // Il etait grise entre 18h et 18h59 seulement, puis de nouveau propose a
    // 19h avec « demain 6h » : buildEta donne deja ce libelle des 18h.
    container.querySelectorAll('[data-delivery-tier]').forEach(function (option) {
      var tier = option.getAttribute('data-delivery-tier');
      var input = option.querySelector('.lcu-wizard__tier-input');
      if (!tier || !input) return;

      var etaNode = option.querySelector('[data-delivery-eta]');
      var benefitNode = option.querySelector('[data-delivery-benefit]');

      option.classList.remove('is-disabled');
      input.disabled = false;
      if (etaNode) etaNode.textContent = buildEta(tier, h);
      if (benefitNode) benefitNode.textContent = benefitNode.getAttribute('data-default-text') || '';
    });

    container.querySelectorAll('.lcu-wizard__tier-input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        syncVariantFromDelivery();
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'lcu_delivery_tier_selected',
            delivery_tier: input.value,
            delivery_price: parseFloat(input.getAttribute('data-option-price')) || 0
          });
        } catch (e) {
        }
      });
    });

    syncVariantFromDelivery();
  }

  function syncVariantFromDelivery() {
    var variantInput = form.querySelector('input[name="id"]');
    var checked = form.querySelector('.lcu-wizard__tier-input:checked');
    if (!variantInput || !checked) return;
    var variantId = checked.getAttribute('data-variant-id');
    if (variantId) variantInput.value = variantId;
  }

  function recapValueFor(slot) {
    var sources = form.querySelectorAll('[data-recap-slot="' + slot + '"]');
    var values = [];

    Array.prototype.forEach.call(sources, function (node) {
      if (node.type === 'radio' || node.type === 'checkbox') {
        if (!node.checked || node.disabled) return;
        if (node.type === 'checkbox') {
          // data-recap-value permet d'afficher autre chose que le libelle d'addon
          // dans le recapitulatif : sans lui, une option a case unique se lisait
          // « Vidéo karaoké : Vidéo karaoké ». Additif — aucun element existant
          // ne porte cet attribut.
          values.push(
            node.getAttribute('data-recap-value') ||
              node.getAttribute('data-addon-label') ||
              t('recap_yes')
          );
          return;
        }
        // data-recap-label : libelle affiche quand il differe de la valeur
        // envoyee (mode chanteur : « Chris » pour la valeur « Homme »).
        var emoji = node.getAttribute('data-recap-emoji');
        var shown = node.getAttribute('data-recap-label') || node.value;
        values.push(emoji ? emoji + ' ' + shown : shown);
        return;
      }
      if (node.value) values.push(node.value);
    });

    // Precision tapee sous « Autre » (occasion, style). Elle porte
    // data-recap-extra et non data-recap-slot : le slot alimente aussi
    // l'editeur inline du recap, qui la prendrait pour un choix de plus.
    // toggleReveal vide le champ quand « Autre » n'est plus coche, le test
    // sur [hidden] est une ceinture en plus.
    var extra = '';
    Array.prototype.forEach.call(form.querySelectorAll('[data-recap-extra="' + slot + '"]'), function (node) {
      if (node.value && !node.closest('[hidden]')) extra = node.value.trim();
    });

    if (!values.length) return extra;
    return extra ? values.join(', ') + ' : ' + extra : values.join(', ');
  }

  function refreshRecap() {
    var slots = ['occasion', 'prenom', 'lien', 'souvenirs', 'style', 'ambiance', 'voix', 'couplets', 'phrase', 'video', 'streaming', 'delai'];

    slots.forEach(function (slot) {
      var value = slot === 'souvenirs' ? truncate(fieldValue('lcu-wizard-souvenirs'), 90) : recapValueFor(slot);

      root.querySelectorAll('[data-recap-row="' + slot + '"]').forEach(function (row) {
        var rowStep = parseInt(row.getAttribute('data-recap-step'), 10) || 1;
        row.hidden = !value || rowStep > maxStepReached;
      });
      root.querySelectorAll('[data-recap-value="' + slot + '"]').forEach(function (node) {
        node.textContent = value;
      });
    });

    refreshHero();
  }

  function refreshHero() {
    var hero = root.querySelector('[data-recap-hero]');
    if (!hero) return;

    var name = recapValueFor('prenom');
    if (!name) {
      hero.hidden = true;
      return;
    }
    hero.hidden = false;
    hero.querySelector('[data-recap-hero-name]').textContent = name;

    var etaNode = hero.querySelector('[data-recap-hero-eta]');
    var checkedTier = form.querySelector('.lcu-wizard__tier-input:checked');
    var tier = checkedTier && checkedTier.closest('[data-delivery-tier]');
    var etaSource = tier && tier.querySelector('[data-delivery-eta]');
    var etaText = etaSource ? etaSource.textContent.trim() : '';

    etaNode.textContent = etaText;
    etaNode.hidden = !etaText;
  }

  function fieldValue(id) {
    var node = document.getElementById(id);
    return node ? node.value.trim() : '';
  }

  function truncate(text, max) {
    if (!text) return '';
    if (text.length <= max) return text;
    return text.slice(0, max).trim() + '…';
  }

  // Champs remplis sans action du visiteur : seuls, ils ne font pas un
  // brouillon a reprendre. La voix est pre-cochee sur un lien chanteur ; un
  // vrai brouillon contient forcement les reponses des etapes 1 a 5.
  var PREFILLED_FIELDS = [
    'properties[Délai de livraison]',
    'properties[Voix]',
    'properties[Chanteur]',
    'properties[_Lien chanteur]'
  ];

  function hasRealAnswers(fields) {
    return Object.keys(fields).some(function (name) {
      return PREFILLED_FIELDS.indexOf(name) === -1;
    });
  }

  function collectDraft() {
    var data = { step: currentStep, savedAt: Date.now(), fields: {}, addons: [] };

    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.type === 'radio' || field.type === 'checkbox') {
        if (field.checked) data.fields[field.name] = field.value;
        return;
      }
      if (field.value) data.fields[field.name] = field.value;
    });

    form.querySelectorAll('[data-exclusive-group] .lcu-wizard__option-input, [data-recap-slot="streaming"], [data-recap-slot="video"]').forEach(function (input, index) {
      if (input.checked) data.addons.push(input.getAttribute('data-addon-label') || String(index));
    });

    return data;
  }

  function saveDraft() {
    try {
      var draft = collectDraft();
      if (!hasRealAnswers(draft.fields)) return;
      window.localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch (e) {
    }
  }

  function readDraft() {
    try {
      var raw = window.localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      var draft = JSON.parse(raw);
      if (!draft || !draft.savedAt || Date.now() - draft.savedAt > DRAFT_TTL_MS) {
        clearDraft();
        return null;
      }
      return draft;
    } catch (e) {
      return null;
    }
  }

  function clearDraft() {
    try {
      window.localStorage.removeItem(DRAFT_KEY);
    } catch (e) {
    }
  }

  function applyDraft(draft) {
    isRestoring = true;

    Object.keys(draft.fields || {}).forEach(function (name) {
      var value = draft.fields[name];
      var radio = form.querySelector('[name="' + cssEscape(name) + '"][value="' + cssEscape(value) + '"]');
      if (radio && (radio.type === 'radio' || radio.type === 'checkbox')) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var field = form.querySelector('[name="' + cssEscape(name) + '"]');
      if (!field) return;
      field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    (draft.addons || []).forEach(function (label) {
      var input = form.querySelector('[data-addon-label="' + cssEscape(label) + '"]');
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    refreshPrice();
    refreshRecap();

    // On reprend a l'etape sauvegardee, sauf si une etape precedente est
    // incomplete : un brouillon enregistre avant un changement d'ordre des
    // etapes (07/09/2026) pointe sinon sur une question deja passee et laisse
    // un champ obligatoire vide dans une etape masquee. report: false ne
    // touche pas au DOM.
    var target = Math.min(draft.step || 1, RECAP_STEP);
    for (var s = 1; s < target && s <= TOTAL_STEPS; s++) {
      if (!validateStep(s, { report: false })) {
        target = s;
        break;
      }
    }
    showStep(target, { focus: false, scroll: false });
    isRestoring = false;
  }

  // Un saut de ligne brut (souvenirs, ?occasion=) rendait le selecteur
  // invalide : querySelector levait une SyntaxError et la reprise du
  // brouillon s'arretait a l'etape 1. CSS.escape echappe tout ; le repli
  // ajoute les sauts de ligne a l'ancien echappement.
  function cssEscape(value) {
    var text = String(value);
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(text);
    return text.replace(/(["\\])/g, '\\$1').replace(/[\n\r\f]/g, function (c) {
      return '\\' + c.charCodeAt(0).toString(16) + ' ';
    });
  }

  function initResumeBanner() {
    var banner = root.querySelector('[data-wizard-resume]');
    if (!banner) return;

    var draft = readDraft();
    if (!draft || !draft.fields || !hasRealAnswers(draft.fields)) return;

    var name = draft.fields['properties[Prénom]'];
    var textNode = banner.querySelector('[data-wizard-resume-text]');
    if (textNode) {
      textNode.textContent = name ? t('resume_named', { '[name]': name }) : t('resume_title');
    }
    banner.hidden = false;

    var accept = banner.querySelector('[data-wizard-resume-accept]');
    var decline = banner.querySelector('[data-wizard-resume-decline]');

    if (accept) accept.addEventListener('click', function () {
      banner.hidden = true;
      applyDraft(draft);
    });

    if (decline) decline.addEventListener('click', function () {
      banner.hidden = true;
      clearDraft();
    });
  }

  function editorSources(slot) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-recap-slot="' + slot + '"]'));
  }

  function editorLabel(input) {
    var wrap = input.closest('label');
    var node = wrap && wrap.querySelector('.lcu-wizard__card-label, .lcu-wizard__pill-label, .lcu-wizard__option-text');
    var texte = node && node.textContent.trim() ? node.textContent.trim() : input.value;
    var emoji = input.getAttribute('data-recap-emoji');
    return emoji ? emoji + ' ' + texte : texte;
  }

  // ------------------------------------------------------------------
  // Persistance des corrections faites depuis le recapitulatif.
  //
  // Des que la chanson est au panier, c'est le panier qui fait foi :
  // initCartResume() le relit a chaque chargement et ecrase le formulaire ET le
  // brouillon. Une correction faite ici n'ecrivait que dans le brouillon : elle
  // etait donc silencieusement perdue au premier rafraichissement, et le client
  // repartait au paiement avec ses anciennes reponses sans s'en apercevoir.
  //
  // On repousse donc la configuration vers le panier apres chaque edition. Pas
  // de bouton « Enregistrer » : sur une audience senior, un bouton qu'on oublie
  // de cliquer recree exactement la perte qu'on cherche a corriger. La ligne
  // d'etat sous le champ dit ce qui se passe.
  // ------------------------------------------------------------------
  var cartSyncTimer = null;
  var cartSyncSeq = 0;
  var openEditorPanel = null;

  // pushConfigurationToCart fait un retrait-puis-reajout : deux executions
  // entrelacees peuvent doubler la chanson ou laisser le panier sans elle au
  // moment du paiement. Toute ecriture panier (edition du recap comme bouton
  // « Payer ») passe donc par cette file, qui les serialise.
  var cartWriteQueue = Promise.resolve();

  function queueCartWrite() {
    var run = cartWriteQueue.then(function () {
      return pushConfigurationToCart();
    });
    cartWriteQueue = run.catch(function () {});
    return run;
  }

  function setEditorStatus(state) {
    if (!openEditorPanel) return;
    var node = openEditorPanel.querySelector('[data-recap-status]');
    if (!node) return;
    node.textContent = state ? t('recap_' + state) : '';
    node.hidden = !state;
    node.setAttribute('data-state', state || '');
  }

  function songIsInCart() {
    return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return !!cartSongItem(cart);
      })
      .catch(function () {
        return false;
      });
  }

  function syncCartFromRecap() {
    // Le paiement est en cours : sa propre ecriture relira le formulaire et
    // emportera la derniere valeur, inutile de la concurrencer.
    if (isSubmitting) return Promise.resolve();
    var seq = ++cartSyncSeq;

    return songIsInCart()
      .then(function (present) {
        // Rien au panier : le brouillon local suffit, il sera relu par la
        // banniere de reprise. Inutile de creer une ligne de panier que le
        // visiteur n'a pas demandee. Re-test de isSubmitting : le clic
        // « Payer » a pu arriver pendant la lecture du panier ci-dessus, et
        // une ecriture mise en file apres la sienne serait coupee en plein
        // vol par la redirection vers le checkout.
        if (!present || isSubmitting) return 'idle';
        return queueCartWrite().then(function () {
          return 'saved';
        });
      })
      .then(function (state) {
        if (seq !== cartSyncSeq) return;
        setEditorStatus(state === 'idle' ? null : state);
      })
      .catch(function () {
        if (seq !== cartSyncSeq) return;
        setEditorStatus('save_failed');
      });
  }

  function afterInlineEdit() {
    syncVariantFromDelivery();
    refreshPrice();
    refreshRecap();
    saveDraft();

    if (isRestoring || isSubmitting) return;
    setEditorStatus('saving');
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer = window.setTimeout(syncCartFromRecap, 700);
  }

  function buildRadioEditor(panel, sources) {
    var select = document.createElement('select');
    select.className = 'lcu-wizard__select lcu-wizard__recap-select';

    sources.forEach(function (radio) {
      var option = document.createElement('option');
      option.value = radio.value;
      option.textContent = editorLabel(radio);
      option.selected = radio.checked;
      select.appendChild(option);
    });

    // Champ « Précisez » : l'option « Autre » de l'etape ouvre un champ texte
    // (data-toggle-target). Sans ce miroir, choisir « Autre » depuis le recap
    // laissait le client sans moyen de dire quelle occasion (bug du 08/09/2026).
    // Le miroir ecrit dans le champ de l'etape, qui reste la seule source :
    // brouillon, recap et panier le relisent comme d'habitude.
    var extra = null;
    sources.forEach(function (radio) {
      if (extra || !radio.hasAttribute('data-toggle-target')) return;
      var target = document.getElementById(radio.getAttribute('data-toggle-target'));
      var field = target && target.querySelector('input[type="text"], textarea');
      if (field) extra = { radio: radio, field: field };
    });

    var extraWrap = null;
    var extraInput = null;
    if (extra) {
      extraWrap = document.createElement('div');
      extraWrap.className = 'lcu-wizard__recap-extra';
      extraWrap.hidden = true;

      extraInput = document.createElement('input');
      extraInput.type = 'text';
      extraInput.className = 'lcu-wizard__input';
      extraInput.id = 'lcu-wizard-recap-extra-' + (extra.field.getAttribute('data-recap-extra') || extra.field.id);
      extraInput.placeholder = extra.field.placeholder || '';
      extraInput.value = extra.field.value;

      // Meme libelle qu'a l'etape (« Précisez votre occasion »). Sans label a
      // l'etape, le placeholder sert de nom accessible.
      var stepLabel = form.querySelector('label[for="' + cssEscape(extra.field.id) + '"]');
      var extraLabel = null;
      if (stepLabel) {
        extraLabel = document.createElement('label');
        extraLabel.className = 'lcu-wizard__label';
        extraLabel.htmlFor = extraInput.id;
        extraLabel.textContent = stepLabel.textContent.trim();
      } else {
        extraInput.setAttribute('aria-label', extraInput.placeholder);
      }

      extraInput.addEventListener('input', function () {
        extra.field.value = extraInput.value;
        extra.field.dispatchEvent(new Event('input', { bubbles: true }));
        afterInlineEdit();
      });

      if (extraLabel) extraWrap.appendChild(extraLabel);
      extraWrap.appendChild(extraInput);
    }

    function syncExtra() {
      if (!extra) return;
      var show = extra.radio.checked;
      extraWrap.hidden = !show;
      // toggleReveal a deja vide le champ de l'etape quand « Autre » est
      // decoche : on reflete simplement sa valeur.
      extraInput.value = extra.field.value;
    }

    select.addEventListener('change', function () {
      sources.forEach(function (radio) {
        if (radio.value !== select.value || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      syncExtra();
      afterInlineEdit();
      if (extra && extra.radio.checked && !isTouchLike()) extraInput.focus({ preventScroll: true });
    });

    panel.appendChild(select);
    if (extraWrap) {
      panel.appendChild(extraWrap);
      syncExtra();
    }
  }

  function buildCheckboxEditor(panel, sources) {
    var mirrors = [];

    sources.forEach(function (source) {
      var row = document.createElement('label');
      row.className = 'lcu-wizard__recap-check';

      var box = document.createElement('input');
      box.type = 'checkbox';
      box.checked = source.checked;

      var text = document.createElement('span');
      text.textContent = editorLabel(source);

      box.addEventListener('change', function () {
        if (source.checked !== box.checked) source.click();
        afterInlineEdit();
        mirrors.forEach(function (pair) {
          pair.mirror.checked = pair.source.checked;
        });
      });

      row.appendChild(box);
      row.appendChild(text);
      panel.appendChild(row);
      mirrors.push({ mirror: box, source: source });
    });
  }

  function buildTextEditor(panel, source) {
    var isLong = source.tagName === 'TEXTAREA';
    var field = document.createElement(isLong ? 'textarea' : 'input');

    field.className = isLong ? 'lcu-wizard__textarea lcu-wizard__textarea--short' : 'lcu-wizard__input';
    field.value = source.value;
    if (isLong) field.rows = 4;
    if (!isLong) field.type = 'text';

    field.addEventListener('input', function () {
      source.value = field.value;
      source.dispatchEvent(new Event('input', { bubbles: true }));
      afterInlineEdit();
    });

    panel.appendChild(field);
    return field;
  }

  // Ouverture d'un editeur du recapitulatif. Sur mobile, donner le focus au
  // champ ouvre le clavier par-dessus le recapitulatif qu'on est en train de
  // relire : on focus le panneau (annonce par les lecteurs d'ecran) et on
  // l'amene dans l'ecran, le clavier attend que le client touche le champ.
  function revealEditor(control, panel) {
    if (!isTouchLike()) {
      if (control) control.focus({ preventScroll: true });
      return;
    }

    panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
  }

  function buildEditor(slot, panel) {
    panel.innerHTML = '';

    var sources = editorSources(slot);
    if (!sources.length) return null;

    if (sources[0].type === 'radio') {
      buildRadioEditor(panel, sources);
    } else if (sources[0].type === 'checkbox') {
      buildCheckboxEditor(panel, sources);
    } else {
      buildTextEditor(panel, sources[0]);
    }

    // Ligne d'etat de l'enregistrement. `aria-live` pour que le changement soit
    // annonce sans deplacer le focus, que le visiteur soit au clavier ou non.
    var status = document.createElement('p');
    status.className = 'lcu-wizard__recap-status';
    status.setAttribute('data-recap-status', '');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    panel.appendChild(status);

    return panel.querySelector('select, input, textarea');
  }

  root.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-recap-edit]');
    if (!trigger) return;

    event.preventDefault();

    var slot = trigger.getAttribute('data-recap-edit');
    var panel = root.querySelector('[data-recap-editor="' + slot + '"]');
    if (!panel) return;

    var opening = panel.hidden;

    if (opening) {
      var control = buildEditor(slot, panel);
      panel.hidden = false;
      openEditorPanel = panel;
      revealEditor(control, panel);
    } else {
      panel.hidden = true;
      panel.innerHTML = '';
      if (openEditorPanel === panel) openEditorPanel = null;
    }

    trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });

  function cartSongItem(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && Object.keys(item.properties).length > 0) return item;
    }
    return null;
  }

  function applyProperty(name, value) {
    var nodes = form.querySelectorAll('[name="properties[' + name + ']"]');
    if (!nodes.length) return;

    var first = nodes[0];

    if (first.type === 'radio') {
      Array.prototype.forEach.call(nodes, function (radio) {
        if (radio.value !== value || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return;
    }

    if (first.type === 'checkbox') {
      if (first.checked) return;
      first.checked = true;
      first.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    first.value = value;
    first.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function restoreFromCart(cart, song) {
    isRestoring = true;

    Object.keys(song.properties).forEach(function (key) {
      applyProperty(key, song.properties[key]);
    });

    var tier = form.querySelector('.lcu-wizard__tier-input[data-variant-id="' + song.variant_id + '"]');
    if (tier && !tier.checked) {
      tier.checked = true;
      tier.dispatchEvent(new Event('change', { bubbles: true }));
    }

    cart.items.forEach(function (item) {
      if (item.key === song.key) return;
      var label = root.querySelector('label[data-variant-id="' + item.variant_id + '"]');
      var input = label && label.querySelector('input');
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    isRestoring = false;

    maxStepReached = RECAP_STEP;
    syncVariantFromDelivery();
    refreshPrice();
    showStep(RECAP_STEP, { focus: false, scroll: false });

    var restart = root.querySelector('[data-wizard-restart-wrap]');
    if (restart) restart.hidden = false;
  }

  function initCartResume() {
    return fetch(routeFor('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var song = cartSongItem(cart);
        if (!song) return false;
        restoreFromCart(cart, song);
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  root.addEventListener('click', function (event) {
    var restart = event.target.closest('[data-wizard-restart]');
    if (!restart) return;

    event.preventDefault();
    restart.disabled = true;

    fetch(routeFor('cart_url', '/cart') + '/clear.js', { method: 'POST' })
      .then(function () {
        clearDraft();
        window.location.reload();
      })
      .catch(function () {
        restart.disabled = false;
      });
  });

  function initUrlPrefill() {
    var params = new URLSearchParams(window.location.search);
    var occasion = params.get('occasion');
    if (!occasion) return;

    var radio = form.querySelector('input[name="properties[Occasion]"][value="' + cssEscape(occasion) + '"]');
    if (!radio) return;

    isRestoring = true;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    isRestoring = false;

  }

  function collectProperties() {
    syncSingerProperty();
    var properties = {};
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (key.indexOf('properties[') !== 0) return;
      var name = key.slice(11, -1);
      if (value !== '') properties[name] = value;
    });
    return properties;
  }

  function selectedAddonState() {
    var state = {};

    root.querySelectorAll('label[data-variant-id]').forEach(function (label) {
      var id = parseInt(label.getAttribute('data-variant-id'), 10);
      var input = label.querySelector('input');
      if (!id || !input) return;
      state[id] = !!input.checked && !input.disabled;
    });

    return state;
  }

  function collectAddons() {
    var items = [];
    var seen = {};

    root.querySelectorAll('label[data-variant-id]').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input || !input.checked || input.disabled) return;

      var id = parseInt(label.getAttribute('data-variant-id'), 10);
      if (!id || seen[id]) return;
      seen[id] = true;
      items.push({ id: id, quantity: 1 });
    });

    return items;
  }

  function mainVariantIds() {
    var ids = [];
    form.querySelectorAll('.lcu-wizard__tier-input[data-variant-id]').forEach(function (input) {
      var id = parseInt(input.getAttribute('data-variant-id'), 10);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function cartResponse(response) {
    var parsed = response.json().catch(function () {
      return {};
    });

    if (response.ok) return parsed;

    return parsed.then(function (payload) {
      var error = new Error(payload.description || t('cart_error'));
      error.customerMessage = payload.description || t('cart_error');
      throw error;
    });
  }

  function setPayError(message) {
    var node = root.querySelector('[data-wizard-pay-error]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  function restorePayButton(button) {
    isSubmitting = false;
    if (!button) return;
    button.disabled = false;
    var label = button.querySelector('.lcu-wizard__pay-label');
    if (label) label.textContent = button.getAttribute('data-label') || label.textContent;
  }

  // Ecrit la configuration courante dans le panier : retire les variantes
  // principales obsoletes, purge les options decochees, reajoute la chanson avec
  // ses proprietes puis les options manquantes.
  //
  // Cette chaine sert a la fois au bouton de paiement et a l'edition depuis le
  // recapitulatif. Elle est le SEUL endroit qui ecrit la configuration au
  // panier : dupliquer cette logique cote edition aurait fait diverger les deux
  // chemins, alors que le delai change la variante et que chaque option est une
  // ligne de panier a part entiere.
  function pushConfigurationToCart() {
    syncVariantFromDelivery();

    var properties = collectProperties();
    var addons = collectAddons();
    var checked = form.querySelector('.lcu-wizard__tier-input:checked');
    var variantId = checked && checked.getAttribute('data-variant-id')
      ? parseInt(checked.getAttribute('data-variant-id'), 10)
      : parseInt(new FormData(form).get('id'), 10);

    if (!variantId || isNaN(variantId)) {
      var invalid = new Error('variant');
      invalid.customerMessage = t('cart_error');
      return Promise.reject(invalid);
    }

    var cartUrl = routeFor('cart_url', '/cart');
    var changeUrl = routeFor('cart_change_url', '/cart/change');
    var addUrl = routeFor('cart_add_url', '/cart/add');

    var chain = Promise.resolve();
    mainVariantIds().forEach(function (id) {
      chain = chain.then(function () {
        return fetch(changeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: 0 })
        }).catch(function () {
        });
      });
    });

    return chain
      .then(function () {
        return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var selected = selectedAddonState();
            var existing = {};
            var stale = [];

            (cart.items || []).forEach(function (item) {
              if (!item.quantity) return;
              existing[item.id] = true;
              if (selected[item.id] === false) stale.push(item.id);
            });

            var purge = Promise.resolve();
            stale.forEach(function (id) {
              purge = purge.then(function () {
                return fetch(changeUrl + '.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: String(id), quantity: 0 })
                }).catch(function () {
                });
              });
            });

            return purge.then(function () {
              return addons.filter(function (item) {
                return !existing[item.id];
              });
            });
          })
          .catch(function () {
            return addons;
          });
      })
      .then(function (pendingAddons) {
        return fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
        })
          .then(cartResponse)
          .then(function () {
            return pendingAddons;
          });
      })
      .then(function (pendingAddons) {
        if (!pendingAddons || pendingAddons.length === 0) return null;
        return fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: pendingAddons })
        }).then(cartResponse);
      });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (isSubmitting) return;

    for (var step = 1; step <= TOTAL_STEPS; step++) {
      if (validateStep(step, { report: false })) continue;
      showStep(step);
      validateStep(step);
      return;
    }

    isSubmitting = true;
    setPayError('');
    trackClarity('wizard_pay_click');
    window.clearTimeout(cartSyncTimer);

    var button = root.querySelector('[data-wizard-pay]');
    if (button) {
      button.disabled = true;
      var label = button.querySelector('.lcu-wizard__pay-label');
      if (label) label.textContent = t('adding');
    }

    queueCartWrite()
      .then(function () {
        clearDraft();
        window.location.href = checkoutUrl();
      })
      .catch(function (error) {
        setPayError((error && error.customerMessage) || t('cart_error'));
        restorePayButton(button);
      });
  });

  function scrollToWizard() {
    var section = root.closest('.shopify-section') || root;
    var cible = 0;
    if (section.previousElementSibling) {
      cible = Math.max(0, Math.round(section.getBoundingClientRect().top + (window.pageYOffset || 0)));
    }
    window.scrollTo({ top: cible, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    root.focus({ preventScroll: true });
  }

  function initSamePageCta() {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link || link.target || link.hasAttribute('download')) return;

      var brut = (link.getAttribute('href') || '').trim();
      if (brut === '#lcu-wizard') {
        // Icone panier sur la page du wizard : on defile jusqu'au recapitulatif.
        event.preventDefault();
        scrollToWizard();
        return;
      }
      if (!brut || brut.charAt(0) === '#') return;

      if (link.closest('#cart-icon-bubble, .header__icon--cart')) return;

      var cible;
      try {
        cible = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }
      if (cible.origin !== window.location.origin) return;
      if (cible.pathname !== window.location.pathname) return;
      if (cible.search !== window.location.search) return;
      if (cible.hash) return;

      event.preventDefault();
      scrollToWizard();
    });
  }

  // ------------------------------------------------------------------
  // Mode chanteur (lien publicitaire ?chanteur=<identifiant>).
  //
  // Les chanteurs sont des blocs de la section, exposes en JSON. Le lien active
  // le chanteur pour la session de l'onglet (sessionStorage) : un CTA qui
  // recharge la page sans le parametre ne le perd pas. La reprise d'un
  // brouillon ou du panier le reactive via la propriete masquee
  // « _Lien chanteur ».
  //
  // Seuls les LIBELLES des voix changent : les valeurs envoyees (Homme / Femme
  // / Duo) restent celles qu'attendent le dashboard et la generation Suno. Le
  // chanteur part dans la propriete « Chanteur », seulement si la voix choisie
  // l'inclut (seul ou en duo). Sans chanteur configure ou reconnu : aucun effet.
  // ------------------------------------------------------------------
  var SINGER_KEY = 'lcu_wizard_singer';
  var activeSinger = null;

  function readSingers() {
    var node = root.querySelector('[data-wizard-singers]');
    if (!node) return [];
    try {
      var list = JSON.parse(node.textContent);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function findSinger(id) {
    if (!id) return null;
    var wanted = String(id).trim().toLowerCase();
    var singers = readSingers();
    for (var i = 0; i < singers.length; i++) {
      var singer = singers[i];
      if (singer && singer.id === wanted && singer.name && (singer.role === 'male' || singer.role === 'female')) {
        return singer;
      }
    }
    return null;
  }

  function voicePill(role) {
    return form.querySelector('.lcu-wizard__pill[data-voice-role="' + role + '"]');
  }

  function setPillText(label, text, hint) {
    if (!label || !text) return;
    var labelNode = label.querySelector('.lcu-wizard__pill-label');
    var input = label.querySelector('input');
    if (labelNode) labelNode.textContent = text;
    // Meme libelle dans le recap et dans le detail du prix (ligne du duo).
    if (input) {
      input.setAttribute('data-recap-label', text);
      input.setAttribute('data-breakdown-label', text);
    }

    if (!hint) return;
    var hintNode = label.querySelector('.lcu-wizard__pill-hint');
    if (!hintNode) {
      var textWrap = label.querySelector('.lcu-wizard__pill-text');
      if (!textWrap) return;
      hintNode = document.createElement('span');
      hintNode.className = 'lcu-wizard__pill-hint';
      textWrap.appendChild(hintNode);
    }
    hintNode.textContent = hint;
  }

  function showSingerPhoto(label, photo) {
    if (!label || !photo || label.querySelector('.lcu-wizard__pill-photo')) return;
    var face = label.querySelector('.lcu-wizard__pill-face');
    if (!face) return;

    var img = photo.cloneNode(false);
    img.className = 'lcu-wizard__pill-photo';
    img.width = 40;
    img.height = 40;

    var emoji = face.querySelector('.lcu-wizard__pill-emoji');
    if (emoji) emoji.hidden = true;
    face.insertBefore(img, face.firstChild);
  }

  function relabelVoices(singer, banner) {
    var otherRole = singer.role === 'male' ? 'female' : 'male';
    var own = voicePill(singer.role);
    if (!own) return;

    setPillText(own, singer.name, t('singer_voice_hint'));
    showSingerPhoto(own, banner && banner.querySelector('.lcu-wizard__singer-photo'));
    setPillText(voicePill(otherRole), t('singer_other_' + otherRole));
    setPillText(voicePill('duo'), t('singer_duo_' + otherRole, { '[name]': singer.name }));

    // La voix du chanteur en premier, et cochee si aucune voix ne l'est
    // encore. Sans evenement : pas d'avance automatique, pas de brouillon.
    var list = own.parentNode;
    if (list && list.firstElementChild !== own) list.insertBefore(own, list.firstElementChild);

    var ownInput = own.querySelector('input[type="radio"]');
    if (ownInput && !form.querySelector('input[name="properties[Voix]"]:checked')) {
      ownInput.checked = true;
    }
  }

  function syncSingerProperty() {
    var source = form.querySelector('[data-singer-source]');
    if (source) {
      source.disabled = !activeSinger;
      source.value = activeSinger ? activeSinger.id : '';
    }

    var field = form.querySelector('[data-singer-property]');
    if (!field) return;

    var included = false;
    var role = null;
    if (activeSinger) {
      var checked = form.querySelector('input[name="properties[Voix]"]:checked');
      var pill = checked && checked.closest('[data-voice-role]');
      role = pill && pill.getAttribute('data-voice-role');
      included = role === activeSinger.role || role === 'duo';
    }
    field.disabled = !included;
    field.value = included ? activeSinger.name : '';
    refreshPaySinger(included ? role : null);
  }

  // Ligne « Chantée par Chris, la voix de la vidéo » au-dessus du paiement.
  // Meme condition que la propriete « Chanteur » : la voix choisie comprend le
  // chanteur du lien, seul ou en duo. Sinon la ligne reste masquee.
  function refreshPaySinger(role) {
    var line = form.querySelector('[data-pay-singer]');
    if (!line) return;

    var key = '';
    if (activeSinger && role === activeSinger.role) key = 'pay_singer';
    if (activeSinger && role === 'duo') key = 'pay_singer_duo_' + (activeSinger.role === 'male' ? 'female' : 'male');
    var text = key ? t(key) : '';
    if (!text || text.indexOf('[name]') === -1) {
      line.hidden = true;
      return;
    }

    // Reconstruite seulement quand le texte change : la fonction tourne a
    // chaque modification du formulaire.
    if (line.getAttribute('data-pay-singer-key') !== key) {
      line.textContent = '';
      var photo = root.querySelector(
        '[data-singer-banner="' + cssEscape(activeSinger.id) + '"] .lcu-wizard__singer-photo'
      );
      if (photo) {
        var img = photo.cloneNode(false);
        img.className = 'lcu-wizard__pay-singer-photo';
        img.width = 24;
        img.height = 24;
        line.appendChild(img);
      }

      // Le prenom en gras, sans innerHTML : il vient du dashboard.
      var parts = text.split('[name]');
      var label = document.createElement('span');
      label.appendChild(document.createTextNode(parts[0]));
      var name = document.createElement('strong');
      name.textContent = activeSinger.name;
      label.appendChild(name);
      label.appendChild(document.createTextNode(parts.slice(1).join(activeSinger.name)));
      line.appendChild(label);
      line.setAttribute('data-pay-singer-key', key);
    }
    line.hidden = false;
  }

  function activateSinger(singer) {
    if (!singer || activeSinger) return;
    activeSinger = singer;

    try {
      window.sessionStorage.setItem(SINGER_KEY, singer.id);
    } catch (e) {
    }

    var banner = root.querySelector('[data-singer-banner="' + cssEscape(singer.id) + '"]');
    if (banner) {
      banner.hidden = false;
      // Le bandeau remplace l'accroche generique (deja pose par le script
      // inline de la section quand le chanteur vient de l'URL).
      if (banner.parentNode && banner.parentNode.classList) {
        banner.parentNode.classList.add('lcu-wizard__intro--singer');
      }
    }

    relabelVoices(singer, banner);
    syncSingerProperty();
    refreshRecap();
    trackClarity('wizard_singer', { wizard_singer: singer.id });
  }

  function initSinger() {
    var source = form.querySelector('[data-singer-source]');
    if (!source) return;

    var fromUrl = null;
    var stored = null;
    try {
      fromUrl = new URLSearchParams(window.location.search).get('chanteur');
    } catch (e) {
    }
    try {
      stored = window.sessionStorage.getItem(SINGER_KEY);
    } catch (e) {
    }

    activateSinger(findSinger(fromUrl) || findSinger(stored));

    // Reprise du brouillon ou du panier : ces champs sont ecrits par
    // applyDraft / applyProperty. On reactive le chanteur de la commande et on
    // recalcule « Chanteur » d'apres la voix restauree.
    ['input', 'change'].forEach(function (type) {
      source.addEventListener(type, function () {
        if (!activeSinger) activateSinger(findSinger(source.value));
        syncSingerProperty();
      });
    });

    var field = form.querySelector('[data-singer-property]');
    if (field) field.addEventListener('input', syncSingerProperty);
  }

  form.addEventListener('change', function (event) {
    syncSingerProperty();
    refreshPrice();
    refreshRecap();
    saveDraft();
    clearStepErrorForField(event.target);
  });

  form.addEventListener('input', function (event) {
    refreshRecap();
    clearStepErrorForField(event.target);
  });

  function clearStepErrorForField(field) {
    var step = field && field.closest ? field.closest('.lcu-wizard__step') : null;
    if (step) clearStepErrorIfValid(parseInt(step.getAttribute('data-step'), 10));
  }

  var saveTimer = null;
  form.addEventListener('input', function () {
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(saveDraft, 500);
  });

  initConditionalFields();
  initCharCounters();
  initExclusiveOptions();
  initDeliverySelector();
  initSamePageCta();
  initSinger();
  refreshPrice();
  refreshRecap();

  form.noValidate = true;

  root.setAttribute('data-js', 'on');
  showStep(1, { focus: false, scroll: false });

  var foldTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(foldTimer);
    foldTimer = window.setTimeout(syncFold, 150);
  });
  window.addEventListener('load', syncFold);
  window.addEventListener('pageshow', syncFold);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncFold);

  if (window.ResizeObserver) {
    var foldWatcher = new ResizeObserver(function () {
      window.requestAnimationFrame(syncFold);
    });
    [intro, root.querySelector('.lcu-wizard__resume'), root.querySelector('.lcu-wizard__progress'), document.querySelector('.header-wrapper')].forEach(
      function (node) {
        if (node) foldWatcher.observe(node);
      }
    );
  }

  initCartResume().then(function (restored) {
    if (restored) return;
    initResumeBanner();
    initUrlPrefill();
  });
})();
